var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24ZM32.061 32.0609C31.3581 32.7638 30.2184 32.7638 29.5155 32.0609L24 26.5454L18.4846 32.0609C17.7816 32.7638 16.6419 32.7638 15.939 32.0609C15.236 31.358 15.236 30.2183 15.939 29.5153L21.4544 23.9999L15.939 18.4844C15.2361 17.7815 15.2361 16.6418 15.939 15.9388C16.642 15.2359 17.7817 15.2359 18.4846 15.9388L24 21.4543L29.5154 15.9389C30.2184 15.2359 31.3581 15.2359 32.061 15.9389C32.764 16.6418 32.764 17.7815 32.061 18.4844L26.5456 23.9999L32.061 29.5153C32.764 30.2182 32.764 31.3579 32.061 32.0609Z",
    fill: "#FF8F7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error_icon.df739db5af6fa9274b7a281824f9f423.svg";
export { ForwardRef as ReactComponent };